import { Checkbox } from "@/components/ui/checkbox";
import { TableCell, TableRow } from "@/components/ui/table";
import { planLabel } from "@/lib/plans";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "");

const Tick = ({ id, kind, at, onChange }) => (
  <div className="flex flex-col items-center gap-1 w-24">
    <Checkbox checked={!!at} onCheckedChange={(v) => onChange(kind, !!v)} className="h-5 w-5 data-[state=checked]:bg-amber-600 data-[state=checked]:border-amber-600" data-testid={`entry-${kind}-checkbox-${id}`} />
    <span className="text-[10px] text-stone-500 whitespace-nowrap h-3">{fmt(at)}</span>
  </div>
);

export const EntryRow = ({ r, onDispatch }) => (
  <TableRow className={r.posted_at ? "bg-emerald-50/60" : r.packed_at ? "bg-amber-50/60" : ""} data-testid={`admin-entry-row-${r.id}`}>
    <TableCell><Tick id={r.id} kind="packed" at={r.packed_at} onChange={(k, v) => onDispatch(r, k, v)} /></TableCell>
    <TableCell><Tick id={r.id} kind="posted" at={r.posted_at} onChange={(k, v) => onDispatch(r, k, v)} /></TableCell>
    <TableCell className="whitespace-nowrap">{fmt(r.created_at)}</TableCell>
    <TableCell>
      {planLabel(r.plan)}
      <span className={`block mt-1 w-fit whitespace-nowrap text-[11px] px-2 py-0.5 rounded-full ${r.status === "paid" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-900"}`} data-testid={`entry-status-${r.id}`}>
        {r.status === "paid" ? "Paid" : "Sent to payment"}
      </span>
    </TableCell>
    <TableCell className="font-medium">{r.full_name}</TableCell>
    <TableCell>{r.email}<div className="text-stone-500">{r.phone}</div></TableCell>
    <TableCell className="min-w-[220px]">{[r.address_line1, r.address_line2, r.city, r.state].filter(Boolean).join(", ")} – {r.pincode}</TableCell>
    <TableCell className="max-w-[200px] truncate">{r.gift_note}</TableCell>
  </TableRow>
);
